import { useState, useEffect } from 'react';

/**
 * Global dashboard theme hook — persists dark/light preference to localStorage
 * and applies the `dark` class to <html> for Tailwind dark: variants.
 * Import this hook in any component that needs to read or toggle the theme.
 */
export function useDashboardTheme() {
  const [isDark, setIsDark] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem('dashboardTheme');
      return stored !== 'light'; // default: dark
    } catch {
      return true;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    try {
      localStorage.setItem('dashboardTheme', isDark ? 'dark' : 'light');
    } catch { /* ignore */ }
  }, [isDark]);

  return { isDark, toggle: () => setIsDark((d) => !d) };
}
